import { useEffect, useLayoutEffect } from 'react';

// TODO: Remove this hook once the following issue is resolved
// @see https://github.com/facebook/react/pull/26395
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
